<template>
  <div class="footer h-5" :class="{ 'dark-theme-element': darkTheme }">
    <a-row type="flex" class="footer-text-container" align="middle">
      <a-col :span="24"><p class="text-center no-margin">
        v1.3 | Conception : Dany Oliveira da Costa - TPI 2019 | Responsable d'exploitation : <a class="report-bug" href="mailto:daniel.rebetez@rpn.ch">D. Rebetez</a> | <a class="report-bug" href="https://git.s2.rpn.ch/journal-de-travail/app/issues" target="_blank">Rapporter un bug</a></p>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapState({
      darkTheme: state => state.darkTheme
    })
  }
}
</script>

<style scoped lang="scss">
.footer{
  min-height: 45px;
}
.footer-text-container{
  height: 100%;
}
.report-bug{
  text-decoration: underline;
  color: inherit;
}
</style>
